export const BASEPATH = process.env.REACT_APP_BASEPATH ?? ''
export const PROJECT_PATH = 'projects';
export const DOCS_PATH = 'docs';
export const DOCS_URI = 'pages';
export const API_PATH = 'reference';
export const API_URI = 'api';
export const OAS_PATH = 'oas'
export const MODELS_PATH = 'models';
export const SCHEMA_NAME = 'schemas.yaml';
export const LOGO_URL = '/assets/telflow/images/telflow-portal.svg';
export const LOGO_HOST = process.env.REACT_APP_LOGO_HOST ?? '';
export const LOCAL_STORAGE_ID = 'apiDocHidden';
export const HIDE_QUERY_PARAM = 'hide';
export const ARTICLE_REGEX_STRING = '[^\\/]+\\.md';
export const PROJECT_ARTICLE_REGEX_STRING = '.+\\.md';
export const API_REGEX_STRING = '.+\\.yaml|.+\\.json';
export const PROJECT_REGEX = /\.json$/;
export const SWAGGER_JSON_HOST = process.env.REACT_APP_SWAGGER_HOST ?? '';
export const HIDE_TRY_IT_BUTTON = process.env.REACT_APP_HIDE_TRY_IT_BUTTON ?? false;
